import React, { useContext, useState, useEffect, useCallback } from 'react';
import { Item, Button, Label, Segment, Table, Menu, Icon, Container, Grid, Popup, Confirm, Header, Input } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import TechnicianProjectStore from '../../app/stores/technicianprojectStore';
import LoadingComponent from '../../app/layout/LoadingComponent';
import { RouteComponentProps } from 'react-router-dom';

interface DetailParams {
  id: string;
}

const TechnicianSOR : React.FC<RouteComponentProps<DetailParams>> = ({
  match,
  history
}) => {
  const technicianprojectStore = useContext(TechnicianProjectStore);
  const {loadProject, technicianproject, loadTechnicianSORs, techniciansorsByCategory, changeClaimedQty, updateClaimedQty, submitting} = technicianprojectStore;
  
  useEffect(() => {
    loadTechnicianSORs(match.params.id);
    loadProject(match.params.id);
  }, []);

  const [claim, setClaim] = useState(new Map());

  if (!technicianproject) return <LoadingComponent content='Loading project...' />

  

  return (
    <div>
    <span>Address: {technicianproject.address} </span>
    <p><span>Brighten Code: {(techniciansorsByCategory.length > 0) ?  techniciansorsByCategory[0].brightenCode : ''} </span></p>
      <Table celled unstackable size='small'>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell width='2'>Item Name</Table.HeaderCell>
        <Table.HeaderCell>Item Description</Table.HeaderCell>
        <Table.HeaderCell width='1'>Order Qty</Table.HeaderCell>
        <Table.HeaderCell width='1'>Claimed Qty</Table.HeaderCell>
        <Table.HeaderCell>Remark</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
    {techniciansorsByCategory.map(sor => (
      <Table.Row key={sor.id}>
        <Table.Cell>
          <Label>{sor.itemName}</Label>
        </Table.Cell>
        <Table.Cell>{sor.itemDescription}</Table.Cell>
        <Table.Cell>{sor.orderQty}</Table.Cell>
        <Table.Cell>
          <Input
                    name="claimedQty"
                    value={sor.claimedQty}
                    onChange={(e, { value }) => changeClaimedQty(sor.id, value)}
          />
        </Table.Cell>
        <Table.Cell>
        {sor.remark}
        </Table.Cell>
      </Table.Row>
    ))}
    </Table.Body>
  </Table>
  <Button
          loading={submitting}
          onClick={() => updateClaimedQty()}
          floated="left"
          color="blue"
          // type="submit"
          content="Submit"
        />
  </div>
  );
};

export default observer(TechnicianSOR);
